import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {NineToFive} from "../NineToFive";
import {gsap} from "gsap";
import {NineToFiveSound} from "../sound/NineToFiveSound";
import {NineToFiveTransitionScreenView} from "../view/NineToFiveTransitionScreenView";
import {NineToFiveScatterSymbol} from "../reels/symbols/ScatterSymbol";

export class NineToFiveBetPresentation implements FlowStatePresentation {

    constructor() {}

    public start(flowStateController:FlowStateController) {
        const tl:gsap.core.Timeline = gsap.timeline();
        NineToFiveScatterSymbol.resetScatterCount();

        tl.add(() => {
            NineToFive.soundPlayer.playLoopingSound(NineToFiveSound.REEL_SPINNING);
        });

        NineToFive.baseGameReelView.reelModels.map((reel) => reel.enableXNudge());
        //if (NineToFive.model.data.reels.reduce((a, b) => a.concat(b), []).some((sym) => sym == "C")) {
        if (NineToFive.baseGameReelView.getAllSymbols().some((sym) => sym.symbolName == "C")) {
            NineToFive.baseGameReelView.reelModels.forEach((reel, index) => tl.add(reel.start(), 0));
        } else {
            NineToFive.baseGameReelView.reelModels.forEach((reel, index) => tl.add(reel.start(), `${0.14*index}`));
        }

        tl.add(() => { flowStateController.finish() });
    }
}